/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Device_Security_NoteInputs */



/**
* | output |
* | --- |
* | "Only approve if you just started sign-in from an app you trust. This grants it access to your account." |
*
* @param {Auth_Device_Security_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_device_security_note = /** @type {((inputs?: Auth_Device_Security_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Device_Security_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmige nur, wenn du gerade die Anmeldung aus einer vertrauenswürdigen App gestartet hast. Dies gewährt ihr Zugriff auf dein Konto.")
	return /** @type {LocalizedString} */ ("Only approve if you just started sign-in from an app you trust. This grants it access to your account.")
});